import { CpfCnpjPipe } from './../../../shared/cpf-cnpj.pipe';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChildren, ElementRef, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { Transfer } from '../../models/transfer';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { EventTypes } from '../../../shared/EventTypes';
import { TransfersOmniEventType } from '../transfers-omni.event.type';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { TransfersOmniService } from '../transfers-omni.service';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';
import { ThemeService } from '../../../shared/theme-service/theme.service';
import { AccountNumberPipe } from '../../../shared/account-number.pipe';
import { Util } from '../../../utils/util';
import { TransactionResponseModel } from '../../transfers-other-banks/transfer-response/models/trasanction-response.model';
import { TransactionHandlerService } from '../../transfers-other-banks/transfer-response/services/transaction-handler.service';
import { TransactionResponseStatus } from '../../transfers-other-banks/transfer-response/models/transaction-response-status.enum';
import { TransferType } from '../../transfers-other-banks/models/transferType.enum';

@Component({
	selector: 'app-omni-transfer-confirmation',
	templateUrl: './transfer-confirmation.component.html',
	styleUrls: ['./transfer-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransferConfirmationComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;
	@Input() showBalance;
	@Output() showBalanceChange: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	private view = '[data-component="transfer-confirmation"]';
	private confirmList: Array<ListItem> = [];
	private sendConfirmedTransfer = false;

	public form: FormGroup;
	public active = false;
	public disabled = false;
	public isAttendant = false;

	constructor(private transferOmniService: TransfersOmniService,
		private autenticationService: AutenticationService,
		private themeService: ThemeService,
		private transactionResponseHandler: TransactionHandlerService
	) {

	}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		AppEventDispatcher.listen(TransfersOmniEventType.STEPS.TRANSFER_CONFIRMATION, data => {

			if (data.show) {
				this.active = true;
				this.show();
			} else {
				this.hide();
			}
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOmniEventType.STEPS.TRANSFER_CONFIRMATION);
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);

		if (this.sendConfirmedTransfer) {
			this.hide();
		}
	}

	show() {

		this.buildConfirmList();

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
		});

		this.showBalanceChange.emit(false);

	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	hide() {
		this.preload(true);
		this.addAuthToken();
		this.disabled = true;
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(pass => {

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);

			this.transferOmniService.confirmTransfer(this.transferData.id, this.transferData.transferType, this.transferData.favoredRemember).subscribe( data => {
				const processedData = Util.keysToCamel(data.Retorno) as TransactionResponseModel;
				const nextView = this.transactionResponseHandler.processResult(processedData, TransferType.ENTRE_CONTAS, this.transferData);

				this.transferData.message = data.Mensagem;
				this.transferData.success = data.Sucesso;
				this.transferData.situation = data.SituacaoTransferencia || data.Retorno.SituacaoTransferencia;
				this.transferData.confirmationCode = data.Retorno.Sequencial;

				if(nextView){				
					if (time > 3) {
						this.hideAfterSend();
					}	else {
						TweenMax.delayedCall(3 - time, () => {
							this.hideAfterSend();
						});
					}
				}
				clearInterval(timeLoader);

			}, error => {
				if (time > 3) {
					this.preload(false);
				}	else {
					TweenMax.delayedCall(3 - time, () => {
						this.preload(false, 3 - time);
					});
				}
				clearInterval(timeLoader);

				if (error.error.Tipo === 'RequestTimeout') {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
					AppEventDispatcher.dispatch(TransfersOmniEventType.INIT, {});
				} else if (error.error.Tipo !== 'tokenDatablinkValidado') {
					this.transferData.message = error.error.Mensagem;
					this.transferData.success = error.error.Sucesso;
					this.hideAfterSend();
				} else {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
					AppEventDispatcher.dispatch(TransfersOmniEventType.ERROR, {step: TransfersOmniEventType.STEPS.TRANSFER_CONFIRMATION});
				}
				this.disabled = false;
			});
		}, error => {
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			AppEventDispatcher.dispatch(TransfersOmniEventType.ERROR, {step: TransfersOmniEventType.STEPS.TRANSFER_CONFIRMATION});
			this.disabled = false;
		});

	}

	hideAfterSend() {

		AppEventDispatcher.dispatch(TransfersOmniEventType.STEPS.TRANSFER_RESULT, {show: true});

		TweenMax.to(this.view, .8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});

	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="transfers-other-banks"] .content', show: active, delay: delay});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 30;
	}

	buildConfirmList() {

		const accNumPipe = new AccountNumberPipe();

		this.confirmList = [];
		this.confirmList.push(new ListItem('Banco:', '613 - Omni Banco', 'cls_mask'));
		this.confirmList.push(new ListItem('Conta:', accNumPipe.transform(this.transferData.destinationAccount), 'cls_mask'));
		this.confirmList.push(new ListItem('Nome do Favorecido:', this.transferData.favoredName, 'cls_mask'));
		const CP = new CpfCnpjPipe();

		this.confirmList.push(new ListItem('CPF/CNPJ:', Util.maskCpfCnpjPix(
			(this.transferData.favoredCpfCnpj).trim()
		), 'cls_mask'));

		this.confirmList.push(new ListItem('Data:', this.transferData.dateLabel));

		const FP = new FormatPricePipe();
		this.confirmList.push(new ListItem('Valor:', FP.transform(this.transferData.value, false), 'cls_mask'));

		this.transferData.resumeList = this.confirmList;
	}

	getMessageConfirmedTransfer(message: boolean) {
		this.sendConfirmedTransfer = message;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-omni/transfer-confirmation/transfer-confirmation.component.ts